import styled from "@emotion/styled"
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import React, { useContext } from "react"
import { useCookies } from 'react-cookie';
import HttpService from "../../services/HttpService";
import { Account } from "../../types/Common";
import { AppContext, ThemePreference } from "../../App";
import { SettingsBrightness, LightMode, DarkMode } from "@mui/icons-material";
import packageJson from "../../../package.json";

const ChangeSizeDialogComponent = (props: {

    account:Account
    open:boolean
    onClose: () => void

    }) => {

    const [account, setAccount] = React.useState(props.account);
    const [showActualMatchDay, setShowActualMatchDay] = React.useState(props.account.showActualMatchDay);

    const ctx = useContext(AppContext);

    const handleSave = () => {
        var formData = new FormData();

        formData.append("id", account.id)
        formData.append("showActualMatchDay", JSON.stringify(showActualMatchDay))

        HttpService.post('/AccountAPI/Account', 
        formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }}
        ).then(res => {
            account.showActualMatchDay = showActualMatchDay
            props.onClose();
        });
    }

    const handleClose = () => {
        props.onClose()
    }

    return (
        <ChangeSizeDialog open={props.open}>
            <DialogTitle display={'flex'} flexDirection={'row'}>
                Einstellungen
            </DialogTitle>
            <DialogContent>
                <Box>
                    {/* <InputLabel>Zoom | {zoomValue}%</InputLabel>
                    <Slider placeholder="" name="Zoom" min={100} max={150} step={1} value={zoomValue} aria-label="Default" valueLabelDisplay="auto" onChange={handleScale} /> */}
                    <FormControlLabel control={<Checkbox checked={showActualMatchDay} onClick={() => showActualMatchDay ? setShowActualMatchDay(false) : setShowActualMatchDay(true)}/>} label="Aktuellen Spieltag öffnen?" />
                    <Box sx={{marginTop: 2}}>
                        <Typography variant="body2" sx={{marginBottom: 1, color: 'text.secondary'}}>Erscheinungsbild</Typography>
                        <ToggleButtonGroup
                            value={ctx?.themePreference ?? 'system'}
                            exclusive
                            onChange={(_, value: ThemePreference | null) => { if (value) ctx?.setThemePreference(value); }}
                            size="small"
                        >
                            <ToggleButton value="system">
                                <SettingsBrightness sx={{marginRight: 0.5}} fontSize="small" />
                                System
                            </ToggleButton>
                            <ToggleButton value="light">
                                <LightMode sx={{marginRight: 0.5}} fontSize="small" />
                                Hell
                            </ToggleButton>
                            <ToggleButton value="dark">
                                <DarkMode sx={{marginRight: 0.5}} fontSize="small" />
                                Dunkel
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Box sx={{marginTop: 3, paddingTop: 2, borderTop: '1px solid', borderColor: 'divider'}}>
                        <Typography variant="caption" sx={{color: 'text.secondary', display: 'block'}}>
                            Version {packageJson.version}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={reset}>ZURÜCKSETZEN</Button> */}
                <Button onClick={handleClose}>SCHLIESSEN</Button>
                <Button onClick={handleSave}>ÜBERNEHMEN</Button>
            </DialogActions>
        </ChangeSizeDialog>
    )
}
export default ChangeSizeDialogComponent

const ChangeSizeDialog = styled(Dialog)(({theme}) => ({
    '& .MuiPaper-root': {
        margin: 0,
        maxHeight: 'calc(100% - 10px)',
        width: 'calc(100% - 10px)',
    }
}))